import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from 'util/axios';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Pagination, { SetPager } from "util/component/Pagination/v2";
import { useDidMountEffect } from "util";

const VIEW_PAGE = 5;

const nexthover = (e) => {
    e.target.closest("tr").nextElementSibling.style = "background-color: #eeeeff";
};
const prevhover = (e) => {
    e.target.closest("tr").previousElementSibling.style = "background-color: #eeeeff";
};
const nexthoverout = (e) => {
    e.target.closest("tr").nextElementSibling.style = null;
};
const prevhoverout = (e) => {
    e.target.closest("tr").previousElementSibling.style = null;
};

const HandleMouseOver = (e) => {
    const { target } = e;
    if (target.closest(".next-hover")) {
        nexthover(e);
    } else if (target.closest(".previous-hover")) {
        prevhover(e);
    }
};
const HandleMouseOut = (e) => {
    const { target } = e;
    if (target.closest(".next-hover")) {
        nexthoverout(e);
    } else if (target.closest(".previous-hover")) {
        prevhoverout(e);
    }
};
const GoReviewPage = async (rowData, userSelector) => {
    const response = await axios
        .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewSheetList", {
            userId: userSelector.userId,
            page:"myPage"
        })
        .then((Response) => Response.data.data.result);
    await axios.post(process.env.REACT_APP_API + "/pcsReview/modifyCallCheck", {
        ...rowData,
        userId: rowData.callUserId,
    });

    const { geneCode, revision, tempYn, uniqueCode, celNm } = rowData;
    const ownerId = response.filter((i) => i.geneCode === rowData.geneCode)
    let isExternal = userSelector.isExternal;
    const url = encodeURI(
        `/review${isExternal ? "-ex" : ""}?geneCode=${geneCode}&revision=${revision}&tempYn=${tempYn}&uniqueCode=${uniqueCode}&celNm=${celNm}&ownerId=${ownerId[0].ownerId}`
    );
    window.location.href = url;
};

const Calling = (props, ref) => {
    const [List, SetList] = useState([]);
    const [Loading, SetLoading] = useState(true);
    const userSelector = useSelector((store) => store.user);
    const { t } = useTranslation(["page"]);

    const TBL_DATA_ORIGIN = useRef([]);
    const TBL_DATA_LIST = useRef([]);
    const [PAGER, SetPAGER] = useState(null);

    const [Sorting, SetSorting] = useState({ column: "reviewing", order: "asc" });

    const [ListCondition, SetListCondition] = useState(0);

    useDidMountEffect(() => {
        getList();
    }, [ListCondition]);

    const getList = async () => {
        SetLoading(true);
        try {
            let response = [];

            response = await axios
                .post(process.env.REACT_APP_API + "/pcsReview/findMyCallList", {
                    userId: userSelector.userId,
                })
                .then((Response) => Response.data.data.result);

            TBL_DATA_ORIGIN.current = response;
            TBL_DATA_LIST.current = TBL_DATA_ORIGIN.current?.filter((f) => f.cmptType === "R") || [];
/*            if (ListCondition === 0) {

            } else {
                TBL_DATA_LIST.current = TBL_DATA_ORIGIN.current || [];
            }*/
            const pager = new SetPager(TBL_DATA_LIST.current.length, VIEW_PAGE);
            SetPAGER({ data: pager });
        } catch (e) {
            SetList([]);
        } finally {
            SetLoading(false);
        }
    };

    useEffect(() => {
        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];
        TBL_DATA_LIST.current?.sort((a, b) => {
            if (Sorting.order === "asc") {
                if (a[Sorting.column] > b[Sorting.column]) return 1;
                if (a[Sorting.column] === b[Sorting.column]) return 0;
                if (a[Sorting.column] < b[Sorting.column]) return -1;
                return 0;
            } else {
                if (a[Sorting.column] > b[Sorting.column]) return -1;
                if (a[Sorting.column] === b[Sorting.column]) return 0;
                if (a[Sorting.column] < b[Sorting.column]) return 1;
                return 0;
            }
        });

        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_LIST.current[i]);
        }
        SetList(setData);
    }, [PAGER, Sorting]);

    const HandleSort = (column) => {
        SetSorting((OLD) => ({ column: column, order: OLD.column === column && OLD.order === "desc" ? "asc" : "desc" }));
    };

    useEffect(() => {
        getList();

        window.addEventListener("mouseover", HandleMouseOver);
        window.addEventListener("mouseout", HandleMouseOut);

        return () => {
            window.removeEventListener("mouseover", HandleMouseOver);
            window.removeEventListener("mouseout", HandleMouseOut);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const HandleCallCheck = async (rowData) => {
        await axios.post(process.env.REACT_APP_API + "/pcsReview/modifyCallCheck", {
            ...rowData,
            userId: rowData.callUserId,
        });
        getList();
    };

    const renderTableData = useMemo(() => {
        if (!Loading && List && List.length > 0) {
            return List.map((rowData, index) => {
                const { tempYn, revision, round, project, process, reviewEnd, dueDate, callCheck, userNm, content } = rowData;
                return (
                    <React.Fragment key={`myCallList${index}`}>
                        <tr
                            className={"clickable next-hover"}
                            onClick={() => {
                                GoReviewPage(rowData, userSelector);
                            }}
                        >
                            <td>{project}</td>
                            <td>{process}</td>
                            <td>
                                <span className={tempYn === "Y" ? "bpl-temp-v2 smaller" : ""}>{revision}</span>
                            </td>
                            <td>{round}</td>
                            <td>{dueDate}</td>
                            <td title={userNm} className={"ellipsis"}>
                                {userNm}
                            </td>
{/*                            <td rowSpan={2} style={{ borderBottomWidth: "3px" }}>
                                <button
                                    style={{ fontSize: "0.75rem" }}
                                    className={"bpl-btn small thin success"}
                                    disabled={callCheck === "Y"}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        HandleCallCheck(rowData);
                                    }}
                                >
                                    {`Confirm${callCheck === "Y" ? "ed" : ""}`}
                                </button>
                            </td>*/}
                        </tr>
                        <tr
                            onClick={() => {
                                GoReviewPage(rowData, userSelector);
                            }}
                            className={"clickable previous-hover"}
                        >
                            <td colSpan={6} className={"text-left ellipsis"} style={{ borderBottomWidth: "3px" }}>
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            </td>
                        </tr>
                    </React.Fragment>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan={6}>No Results</td>
                </tr>
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [List, Loading]);

    return (
        <div className={"position-relative"}>
            {/* <div>
                <h4>Under Development</h4>
            </div> */}

            <div className={"refresh-btn"} onClick={getList} aria-hidden="true">
                <FontAwesomeIcon icon={faArrowRotateRight} />
            </div>
            <div className={"d-flex justify-center align-center calling-box"}>
{/*                <div
                    className={`item ${ListCondition === 0 ? "on" : ""}`}
                    onClick={() => {
                        SetListCondition(0);
                    }}
                    aria-hidden="true"
                >
                    Unconfirmed
                </div>
                <div className={"seperator"} />
                <div
                    className={`item  ${ListCondition === 1 ? "on" : ""}`}
                    onClick={() => {
                        SetListCondition(1);
                    }}
                    aria-hidden="true"
                >
                    All items
                </div>*/}
            </div>
            <table className={"bpl-table-default small compact has-pagination fixed text-center"} style={{ fontSize: "0.8rem" }}>
                <colgroup>
                    <col width="50" />
                    <col width="50" />
                    <col width="55" />
                    <col width="45" />
                    <col width="110" />
                    <col />
                   {/* <col width="0" />*/}
                </colgroup>
                <thead>
                    <tr>
                        <th
                            className={`clickable sort-header ${Sorting.column === "project" ? Sorting.order : ""}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => HandleSort("project")}
                        >
                            Project
                        </th>
                        <th
                            className={`clickable sort-header ${Sorting.column === "process" ? Sorting.order : ""}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => HandleSort("process")}
                        >
                            Process
                        </th>
                        <th style={{ fontSize: "0.75rem" }}>Revision</th>
                        <th
                            className={`clickable sort-header ${Sorting.column === "round" ? Sorting.order : ""}`}
                            style={{ fontSize: "0.75rem" }}
                            onClick={() => HandleSort("round")}
                        >
                            Round
                        </th>
                        <th
                            className={`clickable sort-header ${Sorting.column === "dueDate" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("dueDate")}
                        >
                            Due Date
                        </th>
                        <th>Caller</th>
                        {/*<th>Status</th>*/}
                    </tr>
                </thead>
                <tbody>{renderTableData}</tbody>
                <tfoot>
                    <tr>
                        <td colSpan="6">
                            <Pagination data={PAGER?.data} v2 set={(data) => SetPAGER({ data: data, refresh: new Date() })} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};
export default Calling;
